import { render } from "./Home.vue?vue&type=template&id=25c7939c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=25c7939c&lang=css"
script.render = render

export default script